import { createAction, props } from '@ngrx/store';
import { BasketItem } from 'graphql-api/gql-api-interfaces';

import { ScannedBasketProduct } from '../models';

export const setBasketScannedProductEntry = createAction(
  '[Scanner] set scanned basket product entry',
  props<{ scannedBasketProduct: ScannedBasketProduct }>(),
);

export const updateScannedProductQuantity = createAction(
  '[Scanner] update scanned product quantity',
  props<{ scannedBasketProduct: ScannedBasketProduct; quantity: number }>(),
);

export const updateScannedProductQuantitySuccess = createAction(
  '[Scanner] update scanned product quantity success',
  props<{ scannedBasketProduct: ScannedBasketProduct }>(),
);

export const updateScannedProductQuantityFailed = createAction(
  '[Scanner] update scanned product quantity fail',
  props<{ scannedBasketProductId: string }>(),
);

export const clearScannedProducts = createAction(
  '[Scanner] Clear scanned products',
);

export const triggerSyncScannedProductsQuantity = createAction(
  '[Scanner] Trigger Sync scanned products quantity',
);

export const syncScannedProductsQuantity = createAction(
  '[Scanner] Sync scanned products quantity',
  props<{
    scannedProducts: ScannedBasketProduct[];
    basketItems: BasketItem[];
  }>(),
);
